export class HubSpotGetObjectDetailsResult {
	properties: { name: string; readonly: boolean }[] = [];
}
